import { Mail, MapPin, Phone } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { brand, contact } from '../../data/siteData.js';
import { serviceTitle, usePublicServices } from '../../hooks/usePublicServices.js';

export const Footer = () => {
  const { t, i18n } = useTranslation();
  const { services } = usePublicServices();

  return (
    <footer className="bg-beam-ink text-white">
      <div className="container-beam grid gap-10 py-14 lg:grid-cols-[1.1fr_0.8fr_0.8fr]">
        <div>
          <img src={brand.whiteLogo} alt="BEAM" className="h-10 w-auto" />
          <p className="mt-6 max-w-md text-sm leading-7 text-white/70">{t('home.subtitle')}</p>
        </div>

        <div>
          <h3 className="text-sm font-extrabold uppercase tracking-[0.25em] text-white/50">{t('nav.services')}</h3>
          <div className="mt-5 grid gap-3">
            {services.map((service) => (
              <Link
                key={service.slug}
                to={`/services/${service.slug}`}
                className="text-sm font-semibold text-white/75 transition hover:text-white"
              >
                {serviceTitle(service, i18n.language, t)}
              </Link>
            ))}
          </div>
        </div>

        <div>
          <h3 className="text-sm font-extrabold uppercase tracking-[0.25em] text-white/50">
            {t('contact.details')}
          </h3>
          <div className="mt-5 grid gap-4 text-sm text-white/75">
            <a href={contact.whatsappUrl} target="_blank" rel="noreferrer" className="flex gap-3 hover:text-white">
              <Phone className="h-5 w-5 text-beam-sky" aria-hidden="true" />
              {contact.phone}
            </a>
            <a href={`mailto:${contact.email}`} className="flex gap-3 hover:text-white">
              <Mail className="h-5 w-5 text-beam-sky" aria-hidden="true" />
              {contact.email}
            </a>
            <p className="flex gap-3 leading-6">
              <MapPin className="mt-0.5 h-5 w-5 shrink-0 text-beam-sky" aria-hidden="true" />
              {contact.address}
            </p>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10 py-5">
        <div className="container-beam flex flex-col gap-3 text-xs font-semibold text-white/50 sm:flex-row sm:items-center sm:justify-between">
          <span>{'\u00a9'} {new Date().getFullYear()} BEAM. Gwaga Group.</span>
          <span>Bujumbura, Burundi</span>
        </div>
      </div>
    </footer>
  );
};
